import React from "react";
import Switch from "react-switch";

const SWITCH_HEIGHT = 30;
const SWITCH_WIDTH = 60;

const SCHEDULING_TIME_FACTOR_PER_LOCATION = 120;
const TIME_CLOCK_TIME_FACTOR_PER_LOCATION = 80;
const CUSTOM_CHECKLISTS_TIME_FACTOR_PER_LOCATION = 52;
const SHIFT_REPORTS_TIME_FACTOR_PER_LOCATION = 52;
const PATRON_COUNTS_TIME_FACTOR_PER_LOCATION = 30;
const ISSUE_TRACKING_TIME_FACTOR_PER_LOCATION = 26;
const EMPLOYEE_MANAGEMENT_TIME_FACTOR_PER_LOCATION = 10;
const CERTIFICATION_TRACKING_TIME_FACTOR_PER_LOCATION = 6;
const MESSAGING_TIME_FACTOR_PER_LOCATION = 6;

const CHEMICAL_RECORDS_TIME_FACTOR_PER_POOL = 52;

const SCHEDULING_TIME_FACTOR_PER_EMPLOYEE = 2.18;
const TIME_CLOCK_TIME_FACTOR_PER_EMPLOYEE = 6.5;
const EMPLOYEE_MANAGEMENT_TIME_FACTOR_PER_EMPLOYEE = 1.09;

const SCHEDULING_PAPER_FACTOR_PER_LOCATION = 108;
const CUSTOM_CHECKLISTS_PAPER_FACTOR_PER_LOCATION = 700;
const SHIFT_REPORTS_PAPER_FACTOR_PER_LOCATION = 365;
const PATRON_COUNTS_PAPER_FACTOR_PER_LOCATION = 26;
const ISSUE_TRACKING_PAPER_FACTOR_PER_LOCATION = 54;

const CHEMICAL_RECORDS_PAPER_FACTOR_PER_POOL = 52;

const SLIDE_INSPECTIONS_TIME_FACTOR_PER_SLIDE = 20;
const SLIDE_INSPECTIONS_PAPER_FACTOR_PER_SLIDE = 365;

const SCHEDULING_PAPER_FACTOR_PER_EMPLOYEE = 16;
const TIME_CLOCK_PAPER_FACTOR_PER_EMPLOYEE = 26;
const EMPLOYEE_MANAGEMENT_PAPER_FACTOR_PER_EMPLOYEE = 2;
const CERTIFICATION_TRACKING_PAPER_FACTOR_PER_EMPLOYEE = 1.25;

class SavingsCalculator extends React.Component {
  state = {
    summerEmployees: 0,
    summerLocations: 0,
    summerBodiesOfWater: 0,
    summerSlides: 0,
    offSeasonEmployees: 0,
    offSeasonLocations: 0,
    offSeasonBodiesOfWater: 0,
    offSeasonSlides: 0,
    staffScheduling: false,
    timeClock: false,
    chemicalRecords: false,
    customChecklists: false,
    customForms: false,
    shiftReports: false,
    patronCounts: false,
    issueTracking: false,
    slideInspections: false,
    privateLessons: false,
    employeeManagement: false,
    messaging: false,
    certificationTracking: false,
    digiStorage: false,
    hoursSaved: 0,
    paperSaved: 0
  };

  calculateSavings = () => {
    var hoursSaved = 0;
    var paperSaved = 0;

    var averageEmployees =
      (3 * this.state.summerEmployees + 9 * this.state.offSeasonEmployees) / 12;
    var averageLocations =
      (3 * this.state.summerLocations + 9 * this.state.offSeasonLocations) / 12;
    var averageBodiesOfWater =
      (3 * this.state.summerBodiesOfWater +
        9 * this.state.offSeasonBodiesOfWater) /
      12;
    var averageSlides =
      (3 * this.state.summerSlides + 9 * this.state.offSeasonSlides) / 12;

    if (this.state.staffScheduling) {
      hoursSaved =
        hoursSaved + averageLocations * SCHEDULING_TIME_FACTOR_PER_LOCATION;

      hoursSaved =
        hoursSaved + averageEmployees * SCHEDULING_TIME_FACTOR_PER_EMPLOYEE;

      paperSaved =
        paperSaved + averageLocations * SCHEDULING_PAPER_FACTOR_PER_LOCATION;

      paperSaved =
        paperSaved + averageEmployees * SCHEDULING_PAPER_FACTOR_PER_EMPLOYEE;
    }

    if (this.state.timeClock) {
      hoursSaved =
        hoursSaved + averageLocations * TIME_CLOCK_TIME_FACTOR_PER_LOCATION;

      hoursSaved =
        hoursSaved + averageEmployees * TIME_CLOCK_TIME_FACTOR_PER_EMPLOYEE;

      paperSaved =
        paperSaved + averageEmployees * TIME_CLOCK_PAPER_FACTOR_PER_EMPLOYEE;
    }

    if (this.state.chemicalRecords) {
      hoursSaved =
        hoursSaved +
        averageBodiesOfWater * CHEMICAL_RECORDS_TIME_FACTOR_PER_POOL;

      paperSaved =
        paperSaved +
        averageBodiesOfWater * CHEMICAL_RECORDS_PAPER_FACTOR_PER_POOL;
    }

    if (this.state.customChecklists) {
      hoursSaved =
        hoursSaved +
        averageLocations * CUSTOM_CHECKLISTS_TIME_FACTOR_PER_LOCATION;

      paperSaved =
        paperSaved +
        averageLocations * CUSTOM_CHECKLISTS_PAPER_FACTOR_PER_LOCATION;
    }

    if (this.state.shiftReports) {
      hoursSaved =
        hoursSaved + averageLocations * SHIFT_REPORTS_TIME_FACTOR_PER_LOCATION;

      paperSaved =
        paperSaved + averageLocations * SHIFT_REPORTS_PAPER_FACTOR_PER_LOCATION;
    }

    if (this.state.patronCounts) {
      hoursSaved =
        hoursSaved + averageLocations * PATRON_COUNTS_TIME_FACTOR_PER_LOCATION;

      paperSaved =
        paperSaved + averageLocations * PATRON_COUNTS_PAPER_FACTOR_PER_LOCATION;
    }

    if (this.state.issueTracking) {
      hoursSaved =
        hoursSaved + averageLocations * ISSUE_TRACKING_TIME_FACTOR_PER_LOCATION;

      paperSaved =
        paperSaved +
        averageLocations * ISSUE_TRACKING_PAPER_FACTOR_PER_LOCATION;
    }

    if (this.state.slideInspections) {
      hoursSaved =
        hoursSaved + averageSlides * SLIDE_INSPECTIONS_TIME_FACTOR_PER_SLIDE;

      paperSaved =
        paperSaved + averageSlides * SLIDE_INSPECTIONS_PAPER_FACTOR_PER_SLIDE;
    }

    if (this.state.employeeManagement) {
      hoursSaved =
        hoursSaved +
        averageLocations * EMPLOYEE_MANAGEMENT_TIME_FACTOR_PER_LOCATION;

      hoursSaved =
        hoursSaved +
        averageEmployees * EMPLOYEE_MANAGEMENT_TIME_FACTOR_PER_EMPLOYEE;

      paperSaved =
        paperSaved +
        averageEmployees * EMPLOYEE_MANAGEMENT_PAPER_FACTOR_PER_EMPLOYEE;
    }

    if (this.state.messaging) {
      hoursSaved =
        hoursSaved + averageLocations * MESSAGING_TIME_FACTOR_PER_LOCATION;
    }

    if (this.state.certificationTracking) {
      hoursSaved =
        hoursSaved +
        averageLocations * CERTIFICATION_TRACKING_TIME_FACTOR_PER_LOCATION;

      paperSaved =
        paperSaved +
        averageEmployees * CERTIFICATION_TRACKING_PAPER_FACTOR_PER_EMPLOYEE;
    }

    this.setState({
      hoursSaved: hoursSaved ? (hoursSaved / 12).toFixed(0) : 0,
      paperSaved: paperSaved ? (paperSaved / 12).toFixed(0) : 0
    });
  };

  handleInputChange = event => {
    var that = this;

    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState(
      {
        [name]: value
      },
      () => {
        that.calculateSavings();
      }
    );
  };

  toggleColumn = (e, column) => {
    var that = this;

    this.setState(
      {
        [column]: e
      },
      () => {
        that.calculateSavings();
      }
    );
  };

  render() {
    var that = this;

    return (
      <div>
        <p className="grey-text text-darken-2 center-align sales-p">
          Tell us about your operation
        </p>

        <hr className="style-hr" />

        <div className="row">
          <form className="col s12">
            <div className="row">
              <div className="input-field col s3">
                <input
                  name="summerEmployees"
                  placeholder="150"
                  type="number"
                  className="indigo-input"
                  value={this.state.summerEmployees}
                  onChange={this.handleInputChange}
                />
                <label className="indigo-input">
                  # Employees Working During Summer
                </label>
              </div>
              <div className="input-field col s3">
                <input
                  name="summerLocations"
                  placeholder="4"
                  type="number"
                  className="indigo-input"
                  value={this.state.summerLocations}
                  onChange={this.handleInputChange}
                />
                <label className="indigo-input">
                  # Locations Operating During Summer
                </label>
              </div>
              <div className="input-field col s3">
                <input
                  name="summerBodiesOfWater"
                  placeholder="10"
                  type="number"
                  className="indigo-input"
                  value={this.state.summerBodiesOfWater}
                  onChange={this.handleInputChange}
                />
                <label className="indigo-input">
                  # Bodies of Water Operating During Summer
                </label>
              </div>
              <div className="input-field col s3">
                <input
                  name="summerSlides"
                  placeholder="5"
                  type="number"
                  className="indigo-input"
                  value={this.state.summerSlides}
                  onChange={this.handleInputChange}
                />
                <label className="indigo-input">
                  # Slides Operating During Summer
                </label>
              </div>
              <div className="input-field col s3">
                <input
                  name="offSeasonEmployees"
                  placeholder="50"
                  type="number"
                  className="indigo-input"
                  value={this.state.offSeasonEmployees}
                  onChange={this.handleInputChange}
                />
                <label className="indigo-input">
                  # Employee Working During Off-Season
                </label>
              </div>
              <div className="input-field col s3">
                <input
                  name="offSeasonLocations"
                  placeholder="2"
                  type="number"
                  className="indigo-input"
                  value={this.state.offSeasonLocations}
                  onChange={this.handleInputChange}
                />
                <label className="indigo-input">
                  # Locations Operating During Off-Season
                </label>
              </div>
              <div className="input-field col s3">
                <input
                  name="offSeasonBodiesOfWater"
                  placeholder="4"
                  type="number"
                  className="indigo-input"
                  value={this.state.offSeasonBodiesOfWater}
                  onChange={this.handleInputChange}
                />
                <label className="indigo-input">
                  # Bodies of Water Operating During Off-Season
                </label>
              </div>
              <div className="input-field col s3">
                <input
                  name="offSeasonSlides"
                  placeholder="1"
                  type="number"
                  className="indigo-input"
                  value={this.state.offSeasonSlides}
                  onChange={this.handleInputChange}
                />
                <label className="indigo-input">
                  # Slides Operating During Off-Season
                </label>
              </div>
            </div>
          </form>
        </div>

        <p className="grey-text text-darken-2 center-align sales-p">
          Which modules would you like to use?
        </p>

        <hr className="style-hr" />

        <div className="row">
          <div className="col s12">
            <div className="row">
              <div className="col s3">
                <label>
                  <b>Staff Scheduling</b>
                </label>

                <br />

                <Switch
                  checked={that.state.staffScheduling}
                  onChange={e => that.toggleColumn(e, "staffScheduling")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Time Clock</b>
                </label>

                <br />

                <Switch
                  checked={that.state.timeClock}
                  onChange={e => that.toggleColumn(e, "timeClock")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Chemical Records</b>
                </label>

                <br />

                <Switch
                  checked={that.state.chemicalRecords}
                  onChange={e => that.toggleColumn(e, "chemicalRecords")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Custom Checklists</b>
                </label>

                <br />

                <Switch
                  checked={that.state.customChecklists}
                  onChange={e => that.toggleColumn(e, "customChecklists")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Custom Forms</b>
                </label>

                <br />

                <Switch
                  checked={that.state.customForms}
                  onChange={e => that.toggleColumn(e, "customForms")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Shift Reports</b>
                </label>

                <br />

                <Switch
                  checked={that.state.shiftReports}
                  onChange={e => that.toggleColumn(e, "shiftReports")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Patron Counts</b>
                </label>

                <br />

                <Switch
                  checked={that.state.patronCounts}
                  onChange={e => that.toggleColumn(e, "patronCounts")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Issue Tracking</b>
                </label>

                <br />

                <Switch
                  checked={that.state.issueTracking}
                  onChange={e => that.toggleColumn(e, "issueTracking")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Slide Inspections</b>
                </label>

                <br />

                <Switch
                  checked={that.state.slideInspections}
                  onChange={e => that.toggleColumn(e, "slideInspections")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Private Lessons</b>
                </label>

                <br />

                <Switch
                  checked={that.state.privateLessons}
                  onChange={e => that.toggleColumn(e, "privateLessons")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Lessons</b>
                </label>

                <br />

                <Switch
                  checked={that.state.groupLessons}
                  onChange={e => that.toggleColumn(e, "groupLessons")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Employee Management</b>
                </label>

                <br />

                <Switch
                  checked={that.state.employeeManagement}
                  onChange={e => that.toggleColumn(e, "employeeManagement")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Messaging</b>
                </label>

                <br />

                <Switch
                  checked={that.state.messaging}
                  onChange={e => that.toggleColumn(e, "messaging")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>Certification Tracking</b>
                </label>

                <br />

                <Switch
                  checked={that.state.certificationTracking}
                  onChange={e => that.toggleColumn(e, "certificationTracking")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
              <div className="col s3">
                <label>
                  <b>DigiStorage</b>
                </label>

                <br />

                <Switch
                  checked={that.state.diigiStorage}
                  onChange={e => that.toggleColumn(e, "diigiStorage")}
                  onColor="#DADCE1"
                  onHandleColor="#3A4590"
                  handleDiameter={25}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={SWITCH_HEIGHT}
                  width={SWITCH_WIDTH}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
            </div>
          </div>
        </div>

        <hr className="style-hr" />

        <br />

        <h2 className="grey-text text-darken-2 center-align sales-p">
          Estimated Monthly Savings
        </h2>

        <center>
          <h2 className="green-text text-darken-1">
            {this.state.hoursSaved} HOURS SAVED PER MONTH
          </h2>

          <h2 className="pink-text">
            {this.state.paperSaved} SHEETS SAVED PER MONTH
          </h2>

          <h2 className="grey-text text-darken-2 center-align sales-p">
            IMPROVED-RISK MANAGEMENT AND PEACE OF MIND; PRICELESS
          </h2>

          <br />

          <h2 className="container grey-text center-align sales-p">
            * The above numbers represent an estimate of how many hours and
            sheets of paper your organization could save with DigiQuatics. Note:
            the DigiQuatics team often adjusts proposal savings based on the
            context and unique makeup of your operation.
          </h2>
        </center>

        <br />

        <hr className="style-hr" />

        <br />
      </div>
    );
  }
}

export default SavingsCalculator;
